export enum slidesTypes {
  SET_SLIDE_DECKS = 'SET_SLIDE_DECKS',
  SET_SLIDES = 'SET_SLIDES',
  UPLOAD_PROGRESS = 'UPLOAD_PROGRESS',
  UPLOAD_STARTED = 'UPLOAD_STARTED',
  UPLOAD_ENDED = 'UPLOAD_ENDED',
  CANCEL_TOKEN_GENERATED = 'CANCEL_TOKEN_GENERATED',
  UPLOAD_CANCELLED = 'UPLOAD_CANCELLED',
  SLIDE_LISTENERS_ADDED = 'SLIDE_LISTENERS_ADDED',
  PROCESSING_PROGRESS = 'PROCESSING_PROGRESS',
  PROCESSING_ENDED = 'PROCESSING_ENDED',
  PROCESSING_FAILED = 'PROCESSING_FAILED',
  SET_FEATURE_IMAGE = 'SET_FEATURE_IMAGE',
  UNSET_FEATURE_IMAGE = 'UNSET_FEATURE_IMAGE',
  FEATURE_IMAGE_REQUESTED = 'FEATURE_IMAGE_REQUESTED',
  FEATURE_IMAGE_REQUEST_COMPLETED = 'FEATURE_IMAGE_REQUEST_COMPLETED',
  SET_ACTIVE_DECK = 'SET_ACTIVE_DECK',
  SET_PENDING_SLIDES_ID = 'SET_PENDING_SLIDES_ID',
  SET_SLIDE_POSITION = 'SET_SLIDE_POSITION',
  SHOW_SLIDES_CONFIRM_MODAL = 'SHOW_SLIDES_CONFIRM_MODAL',
  HIDE_SLIDES_CONFIRM_MODAL = 'HIDE_SLIDES_CONFIRM_MODAL',
  SET_API_VERSION = 'SET_API_VERSION'
}
